import * as React from "react";
import { ActionCard, Field, TextAreaField } from "@ozpanel/kit";
import { Section, useAuth } from "@ozpanel/ui";

// POST /certs/import: record a certificate an operator obtained elsewhere (a commercial or
// customer-supplied chain). It existed with no console (CLAUDE.md rule 8).
//
// What it does, stated without overclaiming: the certificate is RECORDED in the cluster's store
// (tls_certificates, the key encrypted under app_key). Which certificate a name SERVES then follows
// the store's own rules — an internal (self-signed) one is never made current over a valid public one.
export function CertImport() {
  const { client } = useAuth();
  const [domain, setDomain] = React.useState("");
  const [cert, setCert] = React.useState("");
  const [key, setKey] = React.useState("");
  const missing = !domain.trim() ? "A domain is required." : !cert.trim() ? "Paste the certificate chain (PEM)." : undefined;
  return (
    <Section title="Import a certificate">
      <div className="space-y-3">
        <Field label="Domain" value={domain} onChange={setDomain} mono placeholder="www.example.com" />
        <TextAreaField
          label="Certificate chain (PEM)"
          value={cert}
          onChange={setCert}
          mono
          rows={6}
          placeholder="-----BEGIN CERTIFICATE-----"
          help="The leaf first, then its intermediates."
        />
        <TextAreaField
          label="Private key (PEM)"
          value={key}
          onChange={setKey}
          mono
          rows={4}
          secret
          placeholder="-----BEGIN PRIVATE KEY-----"
          help="Stored encrypted under the cluster's app_key, never shown in a list."
        />
        <ActionCard
          title="Record the certificate"
          description="Parses the chain and records it for the domain in the cluster's certificate store. Recording the same certificate twice changes nothing. A record does not by itself change what a site serves: the store's election picks the current certificate per name."
          actionLabel="Import"
          danger="medium"
          unavailable={missing}
          run={() =>
            client.apiFetch("/certs/import", {
              method: "POST",
              body: JSON.stringify({ domain: domain.trim(), cert_pem: cert, key_pem: key }),
            })
          }
        />
      </div>
    </Section>
  );
}
